import styled from 'styled-components';
import CommonButton from '../../components/atoms/Buttons/CommonBtn';
import Icon from '../../components/atoms/Icon';

export const Container = styled.div<{theme?: any}>`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: ${({theme}) => theme.lightBackground};
  text-align: center;
`;

export const HeaderContainer = styled.div<{top: number}>`
  flex-direction: column;
  text-align: center;
  margin-top: ${({top}) => `${top}px`};
`;

export const PageName = styled.text<{theme?: any}>`
  font-weight: bold;
  font-size: 16px;
  color: ${({theme}) => theme.background};
  line-height: 19px;
`;

export const BackButton = styled.button<{theme?: any}>`
  font-weight: normal;
  font-size: 16px;
  color: ${({theme}) => theme.grayText};
  line-height: 19px;
  position: absolute;
  left: 10px;
  background-color: transparent;
  border-width: 0;

  &:active {
    opacity: 0.3;
  }
`;

export const DetailsContainer = styled.div<{theme?: any}>`
  display: flex;
  flex-direction: column;
  padding: 200;
  text-align: center;
  padding-left: 15px;
  padding-right: 15px;
`;

export const Title = styled.text<{theme?: any}>`
  font-weight: bold;
  font-size: 32px;
  line-height: 37px;
  color: ${({theme}) => theme.background};
  margin-bottom: 10px;
`;

export const Subtitle = styled.text<{
  theme?: any;
  opacity?: number;
  weight?: string;
  color?: string;
  size?: string;
  top?: string;
}>`
  font-weight: ${({weight}) => weight || 'normal'};
  font-size: ${({size}) => size || '14px'};
  line-height: 20px;
  color: ${({theme, color}) => color || theme.darkGrayText};
  opacity: ${({opacity}) => opacity || 1.0};
  margin-top: ${({top}) => top || '0px'};
`;

export const StatusContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 15px;
`;

export const StatusText = styled.text<{theme?: any}>`
  font-weight: bold;
  font-size: 14px;
  line-height: 24px;
  opacity: 0.8;
  color: ${({theme}) => theme.yellowText};
  margin-left: 5px;
`;

export const DataContainer = styled.div<{theme?: any}>`
  height: 100%;
  background-color: ${({theme}) => theme.detailsBG};
  margin-top: 18px;
  border-top-left-radius: 40px;
  border-top-right-radius: 40px;
  text-align: center;
  padding: 32px 20px;
`;

export const Button = styled(CommonButton)`
  width: 100%;
`;

export const IconButton = styled(Icon)`
  &:active {
    opacity: 0.8;
  }
`;

export const BackButtonContainer = styled.div`
  display: flex;
  align-items: left;
  padding: 10px;
`;
